import { Box } from "@mui/material";
import { observer } from "mobx-react";
import React, { useEffect, useMemo, useState } from "react";
import ModalContent from "src/Shared/Components/ModalContent/ModalContent";
import ViewInputControl from "src/Shared/Components/ViewInputControl/ViewInputControl";
import { EDITOR_TYPES } from "src/Shared/Enums";
import { useModal, useStore } from "src/Shared/Hooks";
import { SLAStatus } from "../../Enums";
import { ISelectOption } from "src/Shared/Interfaces";
import { VendorType } from "../../Enums/VendorType";
import { IGridFormControlProps } from "src/Shared/Interfaces/IGridFormControlProps.interface";
import GridFormControl from "src/Shared/Components/GridFormControl/GridFormControl";
import { getFormValidation } from "src/Shared/Components";
import { fields } from "./fields";

type Props = {
  companyForm: any;
};

const SlaComment = ({ companyForm }: Props) => {
  const { close } = useModal();
  const slaForm = useMemo(() => getFormValidation(fields), []);

  const getField = (key: string) => slaForm.$(key);
  const getCompanyField = (key: string) => companyForm.$(key);
  const onSubmitForm = () => {
    if (!slaForm.isValid) {
      slaForm.validate();
      slaForm.showErrors();
      return;
    }
    companyForm.set(slaForm.values());
    console.log(companyForm.values());
    close();
  };
  const {
    rootStore: {
      commonStore: { slaStatus },
    },
  } = useStore();

  const [filteredSlaStatus, setSlaStatus] = useState<ISelectOption[]>();

  useEffect(() => {
    setSlaStatus(
      slaStatus.filter(
        (x) =>
          getCompanyField("isCurrentSLAAvaliable")?.value === true ||
          getCompanyField("isCurrentSLAAvaliable")?.value === "true" ||
          x.value != SLAStatus.CurrentSLA,
      ),
    );
  }, [getCompanyField("isCurrentSLAAvaliable").value]);

  const onSlaStatusChange = (val: SLAStatus) => {
    if (val == SLAStatus.ClientRefused) {
      getField("slaReminderDate").set("rules", "required");
      getField("slaRecipient").set("rules", "required");

      getField("slaRecipient").set(
        "value",
        getCompanyField("primaryCompanyRelationshipManager").value,
      );
    } else {
      // Remove required rules
      getField("slaReminderDate").set("rules", "");
      getField("slaRecipient").set("rules", "");

      // Clear recipient value
      getField("slaRecipient").set("value", null);
    }
  };

  const slaGridProps: IGridFormControlProps = {
    row: 1,
    col: 5,
    spacing: 4,
    itemResponsive: {
      lg: 12,
      md: 12,
      sm: 12,
    },
    inputControls: [
      {
        field: getField("slaStatusID"),
        fieldKey: "slaStatusID",
        type: EDITOR_TYPES.DROPDOWN,
        options: filteredSlaStatus,
        onValueChange(val, _) {
          onSlaStatusChange(val);
        },
      },
      {
        field: getField("slaReminderDate"),
        fieldKey: "slaReminderDate",
        type: EDITOR_TYPES.DATE,
        hidden: !(getField("slaStatusID").value == SLAStatus.ClientRefused),
      },
      {
        field: getField("slaRecipient"),
        fieldKey: "slaRecipient",
        type: EDITOR_TYPES.AUTO_COMPLETE_ASYNC,
        hidden: !(getField("slaStatusID").value == SLAStatus.ClientRefused),
      },
      {
        field: getField("slaComment"),
        fieldKey: "slaComment",
        type: EDITOR_TYPES.TEXT_FIELD,
        rows: 3,
        multiline: true,
      },
    ],
    form: slaForm,
  };

  //

  return (
    <>
      <ModalContent
        buttonText="Save"
        title="SLA Information"
        onSaveButtonClick={() => onSubmitForm()}
      >
        <Box>
          <Box sx={{ mt: 2 }}>
            <GridFormControl {...slaGridProps} />

            {/* <ViewInputControl
              type={EDITOR_TYPES.DROPDOWN}
              form={commentForm}
              field={getField("slaStatusID")}
              options={filteredSlaStatus}
              onValueChange={(val, _) => onSlaStatusChange(val)}
            />
            <ViewInputControl
              type={EDITOR_TYPES.DATE}
              form={commentForm}
              field={getField("slaReminderDate")}
              options={filteredSlaStatus}
            />

            <ViewInputControl
              type={EDITOR_TYPES.AUTO_COMPLETE_ASYNC}
              form={commentForm}
              field={getField("slaRecipient")}
            />

            <ViewInputControl
              type={EDITOR_TYPES.TEXT_FIELD}
              rows={3}
              form={commentForm}
              field={getField("slaComment")}
              multiline={true}
            /> */}
          </Box>
        </Box>
      </ModalContent>
    </>
  );
};

export default observer(SlaComment);
